<template>
  <div class="scroll popups" @click.prevent="close" v-show="showPopup">
    <div
      class="bg-FFFFFF w-full fb fb-col popup"
      :class="showPopup ? 'show-popups' : 'hide-popups'"
    >
      <div
        class="bb font-32 relative fb fb-row fb-cross-center fb-main-between popup-header"
      >
        <div class="ff-medium c-191F25 h-46 lh-46 pl-8">
          <slot name="header"></slot>
        </div>
        <i class="iconfont font-32 ml-12 c-191F25-80 mr-24" @click.stop="close"
          >&#xe605;</i
        >
      </div>
      <div class="p-8-0 p-0-8 scroll item-flex-1  popup-content">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showPopup: this.show
    }
  },
  computed: {},
  watch: {
    show(show) {
      this.showPopup = show
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    close() {
      this.showPopup = false
      this.$emit('close', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.popups {
  background: rgba(0, 0, 0, 0.28);
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  .popup {
    transition: all ease 0.6s;
    border-radius: 11px 11px 0px 0px;
    position: absolute;
    left: 0;
    bottom: -100vh;
    max-height: 80%;
    width: 100%;
  }
  .hide-popups {
    bottom: -100vh;
  }
  .show-popups {
    bottom: 0;
  }
}
</style>
